import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { paymentPagesFeeTypesFetchGet } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const getPaymentPagesFeeTypesFetch = createAsyncThunk(
    'getPaymentPagesFeeTypesFetch/Get',
    async (body, { rejectWithValue }) => {
        try {
            const response = await paymentPagesFeeTypesFetchGet(body);
            const data = response?.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'GET_GQ_ADMIN_PAYMENT_PAGES_FEE_TYPES_FETCH_FAILURE',
                error: err,
                message: 'Oops! something went wrong',
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

const getPaymentPagesFeeTypesFetchSlice = createSlice({
    name: 'getPaymentPagesFeeTypesFetch',
    initialState,
    extraReducers: {
        [getPaymentPagesFeeTypesFetch.pending]: (state) => {
            state.loading = true;
        },
        [getPaymentPagesFeeTypesFetch.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
            state.error = null;
        },
        [getPaymentPagesFeeTypesFetch.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const getPaymentPagesFeeTypesFetchSelector = (state) => state.getPaymentPagesFeeTypesFetch;
export const getPaymentPagesFeeTypesFetchReducer = getPaymentPagesFeeTypesFetchSlice.reducer;
